<template lang="pug">
    layout

        template

            div(slot="title")

                // Title
                title-component.text-xs-center(
                    :title="title"

                    type="h2"
                )

                div.landingPageDescription(v-if="description" )
                    div  {{ description }}
        template
            div.px-3
                v-container
                    v-layout(v-if="themesList" row wrap justify-center)
                        v-flex(xs12 sm6 md6 lg3 xl3 v-for="(item, key) in themesList" :key="`wrapper-theme-${item.value}`")
                            div.my-3

                                // Theme card
                                theme-component(
                                    :key="`theme-${key}`"
                                    :title="item.title"
                                    :image="item.image"
                                    :theme="item.theme"
                                    :status="item.status"
                                    :disabled="item.disabled"
                                    :muted="item.muted"
                                    :duration="item.duration"
                                    :imageAlt="item.imageAlt"
                                    :handleClick="handleClickTheme"
                                )

                    v-layout(v-else row wrap justify-center)
                        list(:sessions="sessions")

</template>

<script>
    import Layout from '../../Layout/Layout';
    import Title from '~components/Title';
    import { landingPages } from '~api';
    import VueTypes from 'vue-types';
    import Theme from '~components/Theme';
    import List from '../SessionsList/List';

    export default {
        components: {
            Layout,
            List,
            TitleComponent: Title,
            ThemeComponent: Theme
        },
        props: {
            id: VueTypes.string.def('')
        },
        data() {
            return {
                title: '',
                description: '',
                themes: [],
                sessions: []
            };
        },
        computed: {
            themesList() {
                if (!this.themes.length) return undefined;

                return this.$t('themes.themes').filter(theme =>
                    this.themes.includes(theme.theme)
                );
            }
        },
        async created() {
            const resp = await landingPages.readPublic(this.id);

            if (resp.ok) {
                const { title, description, sessionsData } = resp.data;
                this.title = title;
                this.description = description;

                const { themes, sessionIds } = JSON.parse(sessionsData);

                this.sessions = sessionIds;
                this.themes = themes.map(theme => theme.value);
            }
        },
        methods: {
            handleClickTheme(theme) {
                const params = {
                    theme,
                    id: this.id
                };

                return this.$router.push({
                    name: 'dashboard.pagesSessionsList',
                    params
                });
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .landingPageDescription
        display: flex
        justify-content: center
        margin-bottom: 15px
        > div
            text-align: center
            max-width: 600px
</style>
